/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FieldMapping } from '../../models/field-mapping';

export interface ApiMasterFieldMappingGetActiveGet$Params {
}

export function apiMasterFieldMappingGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterFieldMappingGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FieldMapping>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterFieldMappingGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FieldMapping>>;
    })
  );
}

apiMasterFieldMappingGetActiveGet.PATH = '/api/Master/FieldMapping/GetActive';
